import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2c19b558 from 'nuxt_plugin_plugin_2c19b558' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_2a7d642e from 'nuxt_plugin_sentryserver_2a7d642e' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_76781ab4 from 'nuxt_plugin_sentryclient_76781ab4' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_e7db81cc from 'nuxt_plugin_plugin_e7db81cc' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_580bb260 from 'nuxt_plugin_pluginclient_580bb260' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_39b39858 from 'nuxt_plugin_pluginserver_39b39858' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_router_4d02aaf6 from 'nuxt_plugin_router_4d02aaf6' // Source: ./router.js (mode: 'all')
import nuxt_plugin_vlazyload_3009d3d8 from 'nuxt_plugin_vlazyload_3009d3d8' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_vuescrollto_5707a742 from 'nuxt_plugin_vuescrollto_5707a742' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_pluginrouting_1b0ea3c8 from 'nuxt_plugin_pluginrouting_1b0ea3c8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_073052d3 from 'nuxt_plugin_pluginmain_073052d3' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_4343ae6a from 'nuxt_plugin_axios_4343ae6a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_325107c0 from 'nuxt_plugin_gtm_325107c0' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_portalvue_5d849fae from 'nuxt_plugin_portalvue_5d849fae' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_dayjsplugin_4095ff33 from 'nuxt_plugin_dayjsplugin_4095ff33' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_errorHandler_caf842d0 from 'nuxt_plugin_errorHandler_caf842d0' // Source: ../plugins/errorHandler (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_webmeter_2dca469d from 'nuxt_plugin_webmeter_2dca469d' // Source: ../plugins/web-meter.js (mode: 'client')
import nuxt_plugin_sentry_3c12fa56 from 'nuxt_plugin_sentry_3c12fa56' // Source: ../plugins/sentry (mode: 'client')
import nuxt_plugin_axiosipinterceptorserver_48cb4132 from 'nuxt_plugin_axiosipinterceptorserver_48cb4132' // Source: ../plugins/axios.ip.interceptor.server.js (mode: 'server')
import nuxt_plugin_app_784ba9a8 from 'nuxt_plugin_app_784ba9a8' // Source: ../plugins/app.js (mode: 'all')
import nuxt_plugin_logTrace_748948c0 from 'nuxt_plugin_logTrace_748948c0' // Source: ../plugins/logTrace.js (mode: 'all')
import nuxt_plugin_debugGlobalMixin_17e8ded4 from 'nuxt_plugin_debugGlobalMixin_17e8ded4' // Source: ../plugins/debugGlobalMixin.js (mode: 'all')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_vueyoutubeembed_63f80476 from 'nuxt_plugin_vueyoutubeembed_63f80476' // Source: ../plugins/vue-youtube-embed.js (mode: 'client')
import nuxt_plugin_vmask_3c04b27e from 'nuxt_plugin_vmask_3c04b27e' // Source: ../plugins/v-mask.js (mode: 'client')
import nuxt_plugin_datepicker_32eeb780 from 'nuxt_plugin_datepicker_32eeb780' // Source: ../plugins/date-picker.js (mode: 'client')
import nuxt_plugin_hreflangmixinserver_2716bbc8 from 'nuxt_plugin_hreflangmixinserver_2716bbc8' // Source: ../plugins/hreflang.mixin.server.js (mode: 'server')
import nuxt_plugin_pluralization_624d5d0d from 'nuxt_plugin_pluralization_624d5d0d' // Source: ../plugins/pluralization.js (mode: 'all')
import nuxt_plugin_dialog_80887e0e from 'nuxt_plugin_dialog_80887e0e' // Source: ../plugins/dialog.js (mode: 'client')
import nuxt_plugin_buttoninnerlinksdirective_7af02439 from 'nuxt_plugin_buttoninnerlinksdirective_7af02439' // Source: ../plugins/button-inner-links.directive.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"lang":"es","meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"},{"http-equiv":"X-UA-Compatible","content":"ie=edge"},{"name":"theme-color","content":"#ffffff"},{"name":"apple-mobile-web-app-title","content":"EBAC"},{"name":"facebook-domain-verification","content":"xxovr0wpum73urzqw7s1xn4rzw3gi2"},{"name":"google-site-verification","content":"yzzTXNX8OXD7QrGXUwIRewJQdvFo53rDEAiKmqGOa_4"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Rubik:wght@300;400;500;900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:wght@400;500;600&display=swap"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Febac.mx\u002Ffavicons\u002Ffavicon-48x48.png","sizes":"48x48"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"https:\u002F\u002Febac.mx\u002Ffavicons\u002Ffavicon.svg"},{"rel":"shortcut icon","href":"https:\u002F\u002Febac.mx\u002Ffavicons\u002Ffavicon.ico"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Febac.mx\u002Ffavicons\u002Fapple-touch-icon.png","sizes":"180x180"},{"rel":"manifest","href":"https:\u002F\u002Febac.mx\u002Ffavicons\u002Fsite.webmanifest"},{"rel":"preconnect","href":"https:\u002F\u002Fdev.visualwebsiteoptimizer.com"}],"script":[{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fvue@2.6.14","body":true,"defer":true},{"src":"https:\u002F\u002Fwidgets.ebac.app\u002Fcookie-consent\u002Fmx\u002Fcookie-consent-init.js","body":true,"defer":true},{"src":"https:\u002F\u002Fwidgets.ebac.app\u002Fcookie-consent\u002Fmx\u002Fcookie-consent.min.js","body":true,"defer":true},{"type":"text\u002Fjavascript","id":"vwoCode","innerHTML":"\nwindow._vwo_code || (function() {\n  var account_id=783517,\n  version=2.0,\n  settings_tolerance=2000,\n  hide_element='body',\n  hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',\n  \u002F* DO NOT EDIT BELOW THIS LINE *\u002F\n  f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text\u002Fjavascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()\u003Ee.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')\u003E-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text\u002Fcss');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https:\u002F\u002Fdev.visualwebsiteoptimizer.com\u002Fj.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();\n"},{"src":"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fapi.js?render=6LfR9OopAAAAAPsHO9XuBuXfIKZR4kukqm9mAMoh","body":true,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TQR2Q6B')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":["script"],"htmlAttrs":{"lang":"es"},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TQR2Q6B&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2c19b558 === 'function') {
    await nuxt_plugin_plugin_2c19b558(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_2a7d642e === 'function') {
    await nuxt_plugin_sentryserver_2a7d642e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_76781ab4 === 'function') {
    await nuxt_plugin_sentryclient_76781ab4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_e7db81cc === 'function') {
    await nuxt_plugin_plugin_e7db81cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_580bb260 === 'function') {
    await nuxt_plugin_pluginclient_580bb260(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_39b39858 === 'function') {
    await nuxt_plugin_pluginserver_39b39858(app.context, inject)
  }

  if (typeof nuxt_plugin_router_4d02aaf6 === 'function') {
    await nuxt_plugin_router_4d02aaf6(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_3009d3d8 === 'function') {
    await nuxt_plugin_vlazyload_3009d3d8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_5707a742 === 'function') {
    await nuxt_plugin_vuescrollto_5707a742(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_1b0ea3c8 === 'function') {
    await nuxt_plugin_pluginrouting_1b0ea3c8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_073052d3 === 'function') {
    await nuxt_plugin_pluginmain_073052d3(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4343ae6a === 'function') {
    await nuxt_plugin_axios_4343ae6a(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_325107c0 === 'function') {
    await nuxt_plugin_gtm_325107c0(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_5d849fae === 'function') {
    await nuxt_plugin_portalvue_5d849fae(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_4095ff33 === 'function') {
    await nuxt_plugin_dayjsplugin_4095ff33(app.context, inject)
  }

  if (typeof nuxt_plugin_errorHandler_caf842d0 === 'function') {
    await nuxt_plugin_errorHandler_caf842d0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webmeter_2dca469d === 'function') {
    await nuxt_plugin_webmeter_2dca469d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentry_3c12fa56 === 'function') {
    await nuxt_plugin_sentry_3c12fa56(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_axiosipinterceptorserver_48cb4132 === 'function') {
    await nuxt_plugin_axiosipinterceptorserver_48cb4132(app.context, inject)
  }

  if (typeof nuxt_plugin_app_784ba9a8 === 'function') {
    await nuxt_plugin_app_784ba9a8(app.context, inject)
  }

  if (typeof nuxt_plugin_logTrace_748948c0 === 'function') {
    await nuxt_plugin_logTrace_748948c0(app.context, inject)
  }

  if (typeof nuxt_plugin_debugGlobalMixin_17e8ded4 === 'function') {
    await nuxt_plugin_debugGlobalMixin_17e8ded4(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueyoutubeembed_63f80476 === 'function') {
    await nuxt_plugin_vueyoutubeembed_63f80476(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmask_3c04b27e === 'function') {
    await nuxt_plugin_vmask_3c04b27e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_32eeb780 === 'function') {
    await nuxt_plugin_datepicker_32eeb780(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_hreflangmixinserver_2716bbc8 === 'function') {
    await nuxt_plugin_hreflangmixinserver_2716bbc8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluralization_624d5d0d === 'function') {
    await nuxt_plugin_pluralization_624d5d0d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dialog_80887e0e === 'function') {
    await nuxt_plugin_dialog_80887e0e(app.context, inject)
  }

  if (typeof nuxt_plugin_buttoninnerlinksdirective_7af02439 === 'function') {
    await nuxt_plugin_buttoninnerlinksdirective_7af02439(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.push(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
